import React from "react";
import LazyLoad from "react-lazyload";
import Annika from "../finalistsheadshot/Annika.jpg";
import Anvith from "../finalistsheadshot/Anvith.jpg";
import Dhanvin from "../finalistsheadshot/Dhanvin.png";
import Kyle from "../finalistsheadshot/Kyle.jpg";
import Zaki from "../finalistsheadshot/Zaki.jpg";
import Jeena from "../finalistsheadshot/Jeena.jpg";
import Shyntas from "../finalistsheadshot/Shyntas.jpg";
import Vriti from "../finalistsheadshot/Vriti.jpg";
import Andrey from "../finalistsheadshot/Andrey.png";
import Malavika from "../finalistsheadshot/Malavika.png";
import Aditya from "../finalistsheadshot/Aditya.jpg";
import Paulean from "../finalistsheadshot/Paulean.jpg";
import Daria from "../finalistsheadshot/Daria.jpg";
import Advika from "../finalistsheadshot/Advika.jpg";
import Shashwat from "../finalistsheadshot/Shashwat.jpg";

const inPersonFinalists = [
  { id: 1, name: "Zaki Farhat", image: Zaki },
  { id: 2, name: "Aditya Singhal", image: Aditya },
  { id: 3, name: "Annika Razdan", image: Annika },
  { id: 4, name: "Vriti Mirchandani", image: Vriti },
  { id: 5, name: "Andrey Vasilyev", image: Andrey },
  { id: 6, name: "Daria Palichov", image: Daria },
  { id: 7, name: "Kyle Yang", image: Kyle },
  { id: 8, name: "Aityk Shyntas", image: Shyntas },
  { id: 9, name: "Malavika Sreehari", image: Malavika },
  { id: 10, name: "Dhanvin Hetarth Patel", image: Dhanvin },
];

const onlineFinalists = [
  { id: 1, name: "Jeena Ali", image: Jeena },
  { id: 2, name: "Paulean Amelly Mikowle M. De Guzman", image: Paulean },
  { id: 3, name: "Advika Madhusudan", image: Advika },
  { id: 4, name: "Shashwat Mishra", image: Shashwat },
  { id: 5, name: "Anvith Yalamanchili", image: Anvith },
];

// Initials fallback for finalists without a headshot on file
const initials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

// Finalist card component
const FinalistCard = ({ image, name }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
      border: "1px solid #e8eef3",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-4px)";
      e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 77, 153, 0.1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.06)";
    }}
  >
    <div
      style={{
        position: "relative",
        paddingTop: "120%",
        backgroundColor: "#f8f9fa",
      }}
    >
      {image ? (
        <LazyLoad once offset={100}>
          <img
            src={image}
            alt={name}
            className="no-invert-image-partners-css"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </LazyLoad>
      ) : (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(135deg, #e8eef3 0%, #d6e1ec 100%)",
            color: "#004d99",
            fontSize: "2.4rem",
            fontWeight: "700",
            letterSpacing: "0.02em",
          }}
        >
          {initials(name)}
        </div>
      )}
    </div>
    <div style={{ padding: "16px", textAlign: "center" }}>
      <h3
        style={{
          fontSize: "0.95rem",
          fontWeight: "600",
          color: "#1a1a2e",
          margin: 0,
        }}
      >
        {name}
      </h3>
    </div>
  </div>
);

function WinnersSix() {
  return (
    <div>
      {/* 4-up grid on desktop, gracefully collapsing on smaller screens */}
      <style>{`
        .iro-finalists-grid {
          grid-template-columns: repeat(5, minmax(0, 1fr));
        }
        @media (max-width: 1100px) {
          .iro-finalists-grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
          }
        }
        @media (max-width: 600px) {
          .iro-finalists-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
      `}</style>

      {/* Header Section */}
      <div style={{ marginBottom: "40px" }}>
        <span
          style={{
            display: "inline-block",
            padding: "6px 14px",
            borderRadius: "6px",
            backgroundColor: "rgba(0, 77, 153, 0.08)",
            color: "#004d99",
            fontSize: "0.85rem",
            fontWeight: "600",
            marginBottom: "16px",
          }}
        >
          June 2026
        </span>
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "16px",
          }}
        >
          2026 IRO Finalists
        </h2>
        <p
          style={{
            fontSize: "1.05rem",
            color: "#555",
            lineHeight: "1.7",
            marginBottom: "16px",
          }}
        >
          <strong>
            Congratulations to the finalists of the 2026 International Research
            Olympiad.
          </strong>{" "}
          After several stages of evaluation, our top scorers advanced to the
          Finals — competing both in person at Harvard and online.
        </p>
      </div>

      {/* Finalists Description */}
      <p
        style={{
          fontSize: "1rem",
          color: "#555",
          lineHeight: "1.8",
          marginBottom: "40px",
          textAlign: "center",
          maxWidth: "800px",
          margin: "0 auto 40px auto",
        }}
      >
        The International Research Olympiad is a platform that strives to create
        and promote research culture among high school students. This is done by
        providing a variety of services, tools, and support that aim to
        streamline the research process. The IRO seeks to give students the
        opportunity to develop their research proficiency, learn new
        methodologies, and collaborate at an international scale.
      </p>

      {/* In-Person Finalists Grid */}
      <div style={{ marginBottom: "30px" }}>
        <h3
          style={{
            fontSize: "1.3rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "8px",
          }}
        >
          In-Person Finalists
        </h3>
        <p
          style={{
            fontSize: "0.95rem",
            color: "#555",
            lineHeight: "1.7",
            marginBottom: "24px",
          }}
        >
          These finalists competed in person at the 2026 International Research
          Olympiad Finals.
        </p>
        <div
          className="iro-finalists-grid"
          style={{
            display: "grid",
            gap: "20px",
          }}
        >
          {inPersonFinalists.map((finalist) => (
            <FinalistCard
              key={finalist.id}
              image={finalist.image}
              name={finalist.name}
            />
          ))}
        </div>
      </div>

      {/* Online Finalists Grid */}
      <div style={{ marginTop: "48px", marginBottom: "30px" }}>
        <h3
          style={{
            fontSize: "1.3rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "8px",
          }}
        >
          Online Finalists
        </h3>
        <p
          style={{
            fontSize: "0.95rem",
            color: "#555",
            lineHeight: "1.7",
            marginBottom: "24px",
          }}
        >
          These finalists competed online at the 2026 International Research
          Olympiad Finals.
        </p>
        <div
          className="iro-finalists-grid"
          style={{
            display: "grid",
            gap: "20px",
          }}
        >
          {onlineFinalists.map((finalist) => (
            <FinalistCard
              key={finalist.id}
              image={finalist.image}
              name={finalist.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default WinnersSix;
